const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconCuentas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.03 20.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.36,15.75a1.82,1.82,0,1,1,1.82-1.82A1.82,1.82,0,0,1,12.36,15.75Zm0-2.64a.82.82,0,1,0,.82.82A.82.82,0,0,0,12.36,13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,14.43H4a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5A.5.5,0,0,1,11,14.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,14.43h-2.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H16a.5.5,0,0,1,.5.5A.5.5,0,0,1,16,14.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.36,7.92A1.82,1.82,0,1,1,14.18,6.1,1.82,1.82,0,0,1,12.36,7.92Zm0-2.64a.82.82,0,1,0,.82.82A.82.82,0,0,0,12.36,5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,6.6H4a.5.5,0,0,1-.5-.5A.51.51,0,0,1,4,5.6h7a.5.5,0,0,1,.5.5A.5.5,0,0,1,11,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,6.6h-2.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H16a.5.5,0,0,1,.5.5A.5.5,0,0,1,16,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.67,11.93a1.82,1.82,0,1,1,1.82-1.82A1.83,1.83,0,0,1,7.67,11.93Zm0-2.64a.82.82,0,0,0,0,1.64.82.82,0,1,0,0-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,10.61H9a.5.5,0,0,1,0-1h7a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.15,10.61H4a.5.5,0,1,1,0-1H6.15a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.53,20H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0h19a.5.5,0,0,1,.5.5v19A.5.5,0,0,1,19.53,20ZM1,19H19V1H1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCuentas);
export default __webpack_public_path__ + "static/media/icon_cuentas.946c1a095a3eb3d9379664f91e8aede6.svg";
export { ForwardRef as ReactComponent };